import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const PhysicalTherapist = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="physical therapist icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M6.9248 0.698975C7.34406 0.00906973 8.24134 -0.20421 8.93359 0.213623C9.62567 0.63147 9.84973 1.55395 9.4209 2.22437L7.64648 5.01343L9.26465 6.62671C9.26465 6.62671 9.76231 7.59834 13.6621 7.59839C14.6664 7.59839 15.6714 8.61839 16.5879 9.29858C18.5142 10.7336 19.9937 12.4495 20 12.4568L17.8545 15.6638C17.3669 16.295 16.4412 16.4015 15.8076 15.9158C15.174 15.43 15.0567 14.5073 15.5537 13.8757L16.3438 12.9431L14.6377 11.4851V16.3435L17.5527 21.8728C17.9232 22.5821 17.6404 23.4665 16.9287 23.8357C16.217 24.2049 15.3295 23.9327 14.959 23.2136L11.7119 16.9998H10.75L6.94434 23.2136C6.54456 23.9132 5.6473 24.156 4.94531 23.7576C4.24365 23.359 3.99974 22.4649 4.39941 21.7654L8 15.9998V9.99976L4 5.30542L6.9248 0.698975ZM13 0.999756C14.6599 0.999756 15.9999 2.33985 16 3.99976C16 5.65976 14.66 6.99976 13 6.99976C11.34 6.99976 10 5.65976 10 3.99976C10.0001 2.33985 11.3401 0.999756 13 0.999756Z"
    />
  </svg>
)
